import React from "react";

export const Header = React.lazy(() =>
    import("./Header/index.page")
);
export const Footer = React.lazy(() =>
    import("./Footer/index.page")
);
export const LandingPage = React.lazy(() =>
    import("./LandingPage/index.page")
);
export const BlogPage = React.lazy(() =>
    import("./Blog/index.page")
);
export const BlogDetailPage = React.lazy(() =>
    import("./BlogDetails/index.page")
);
export const TermsAndConditions = React.lazy(() =>
    import("./TermsAndConditions/index.page")
);
export const PrivacyPolicy = React.lazy(() =>
    import("./PrivacyPolicy/index.page")
);
